export interface IStudentListItemProps {
  id: string;
  photo: string;
  status: StudentStatus;
  name: string;
  hasNewMessage: boolean;
  country: string;
}

export enum StudentStatus {
  DEFAULT = 0,
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3,
}

export interface IStudentProfileWidget {
  id: string;
  actionButtonType?: "edit" | "email";
  onActionButtonClick?: () => any;
  hasUnreadMessage?: boolean;
}

export interface ISchoolStudentApplicationsList {
  studentId: string;
}

export interface IManagedStudentsBackEndModel {
  id: string;
  name: string;
  photo: {
    preview: string;
  };
  studentProfile: {
    country: string;
  };
  studentStatus: null | number;
}

export interface IManagedStudentsFrontEndModel {
  id: string;
  name: string;
  status: StudentStatus;
  photo: string;
  hasNewMessage: boolean;
  country: string;
}

export interface ISchoolStudentsBackEndModel {
  id: string;
  name: string;
  photo: {
    preview: string;
  };
  studentProfile: {
    country: string;
  };
  studentStatus: null | number;
}

export interface ISchoolStudentsFrontEndModel {
  id: string;
  name: string;
  status: StudentStatus;
  photo: string;
  hasNewMessage: boolean;
  country: string;
}
